module.exports = __webpack_public_path__ + "img/rate.f70a09f1.svg";